<template>
    <CardPage :section="9" :page="page" :nextDisabled="nextDisabled" :next="next">
        <slot></slot>
    </CardPage>
</template>

<script>
export default {
    props: {
        page: {
            type: Number,
            required: true
        },
        nextDisabled: {
            type: Function,
            default: () => false
        },
        next: {
            type: String,
            default: function() {
                let defaultNextScreen = this.$store.get(`section9/prepScreens@${this.page}`).defaultNextScreen;

                if (defaultNextScreen) {
                    return `/page/9/${defaultNextScreen}`;
                }

                return null;
            }
        }
    },
    mounted() {
        // when any PrEP adherence screen is visited, flag the whole section as visited.
        this.$store.set(`section9/prepVisited`, true);
    }
};
</script>
